module.exports = __webpack_public_path__ + "static/media/down-arrow-select.8fe8a475.svg";